var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_197_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_221_",
    fill: "#E8EAF0",
    d: "M120.9,200c6.7,0,12.5-5.8,12.5-12.5v-29.2h8.4c5,0,8.4-3.3,8.4-8.4V66.4H49.9v83.5 c0,5,3.3,8.4,8.4,8.4h8.4v29.2c0,6.7,5.8,12.5,12.5,12.5c6.7,0,12.5-5.8,12.5-12.5v-29.2h16.7v29.2 C108.4,194.2,114.2,200,120.9,200z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_222_",
    fill: "#E8EAF0",
    d: "M171,149.9c6.7,0,12.5-5.8,12.5-12.5V78.9c0-6.7-5.8-12.5-12.5-12.5s-12.5,5.9-12.5,12.5 v58.5C158.5,144.1,164.3,149.9,171,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    fill: "#E8EAF0",
    d: "M29,149.9c6.7,0,12.5-5.8,12.5-12.5V78.9c0-6.7-5.8-12.5-12.5-12.5s-12.5,5.9-12.5,12.5 v58.5C16.5,144.1,22.3,149.9,29,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_224_",
    fill: "#E8EAF0",
    d: "M140.1,1.3c-1.7-1.7-4.2-1.7-5.8,0L123,12.4l-0.5,0.5c-6.6-3.3-14.1-5-22.4-5H100l0,0h-0.1 c-8.3,0-15.8,1.7-22.4,5L77,12.4L65.7,1.3c-1.7-1.7-4.2-1.7-5.8,0c-1.7,1.7-1.7,4.2,0,5.8l10.8,10.8c-3.5,2.3-6.7,5.2-9.4,8.5 c-6.6,7.8-10.8,18-11.4,29c0,0.1,0,0.2,0,0.3c0,0.8-0.1,1.5-0.1,2.3H150c0-0.8,0-1.5-0.1-2.3c0-0.1,0-0.2,0-0.3 c-0.6-11-4.8-21.2-11.4-29c-2.8-3.3-5.9-6.1-9.4-8.5l10.8-10.8C141.8,5.4,141.8,2.9,140.1,1.3z M79.1,43.4c-3.5,0-6.3-2.8-6.3-6.3 s2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3S82.6,43.4,79.1,43.4z M120.9,43.4c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3 S124.4,43.4,120.9,43.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.8422d073df590b9f26b91b23d8c6cd75.svg";
export { ForwardRef as ReactComponent };